const LoadingMaskCssClass = {
  VISIBLE: 'loading-mask--visible',
};
export default LoadingMaskCssClass;
